import { ImgProps } from "assets/images/types";

export default function ImgOutubroRosaMain(props: ImgProps) {
	const { height = 259, width = 517 } = props;
	return (
		<img
			src="/assets/images/cases/outubro-rosa/outubro-rosa-card.webp"
			alt="Instituto Protea - Todo mes e Outubro Rosa"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
